import { render, staticRenderFns } from "./UsuarioProdutos.vue?vue&type=template&id=60468c9d&scoped=true&"
import script from "./UsuarioProdutos.vue?vue&type=script&lang=js&"
export * from "./UsuarioProdutos.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioProdutos.vue?vue&type=style&index=0&id=60468c9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60468c9d",
  null
  
)

export default component.exports